var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinLogoJsb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "url(#pattern0_1_414)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1_414",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_414",
    transform: "scale(0.00719424)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_414",
    width: 139,
    height: 139,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIsAAACLCAYAAABRGWr/AAAACXBIWXMAACE3AAAhNwEzWJ96AAAERElEQVR4nO3d701UTRTH8YPxvdxpQKxArEA6ECsAK5AOxAqkBKxAOxA7cCsQGpirFayZ5GxiNmT5LXvOnZvl+0l8Y3yGDfvN/Tszz8FyuTRA8YzfElTEAhmxQEYskBELZMQCGbFARiyQEQtkxAIZsUBGLJARC2TEAhmxQEYskD2f46+q1vHEzE7W/vrWzG5KGW47fawnbzYz5Wodj8zs0sxOzezFhn/608yuShm+T/jxnjybSyy1jhceyqZI1rVoTksZ/kzzKdE9llrHazM7e+R/fufB/Ar+WLhH11hqHa/M7OOOw7RgjjnC5Ot2N+QXsbuG0rw0s+uAcfCAnrfOkV/wO48PibrEUut46keESBeEkqvXkeU0Ycx2dDlMGBeuVyxZp4zjpHGfPOsYS/QpaIVYEu3buyFOQ4l4kQhZr1j+Jo3Lk9xEvWK5SRqXWBL1iiXjjfGC6Qu5esYSfSq6Ch4Pa7rE4i/9Ir/cu1IG3g8l6/3WuV1jvA4Y6g3TFPL1vnVuT3IXO47xgVCm0TUWPx2d+Ky3bbVrnvecfqbT/aFcC6aUoQXzwScyKb76hCfm4U5odlub+vSF9ufI3/W88FPVrT+f+c4tch/sgwsZ74YgIxbIiAUyYoGMWCCb5cL4p8DXdh/57L716aDtiXR7YPlnTk+nuXWeiK88WD1DOtlyXffCA1o9Z+qy+rJbLLWObSH8p6jxShkOtvjZ7cv6EfSjP5cyXG74WavdIR67nvs+7Qn2dSlD1iSye3HNkqQdSXzR/+/gUMzH+1HreOMxToJYEvgri9uESNa9bTH6liXpiCWYn16/bXlNsqsvfhRLRSyB/AsLuw7b0ll2MMQSxPeayT7tPOTMj2wpiCWAX6NE7DUT4VPW9iPEsrvDGW4mlPJ5iGV3Hye+mFW8rHU8jx6UWPZX+LULseyv8KMLsey30B22iGW/hW6dRiz7L+w2mlj2X1gsTH6azsInNK0cBq3zfkjYPnvEkmvjvJP/JkRdJm7K+DZqIE5DOdpR5FUpw/mmCUq+dLfF1OakfM76MFFzXogl3tdShuNtl9j6bLusYIhlhha7bAvvwTxmR4mHhFy3EEusi4DJ1BlTDEKetRBLnJ8RE6h9jF03OEpBLHEi98iLnmIQ8qyFWIIEbyw0y23PiCVG6EXp1OuBVMQSI+NIoG6ZNhliiZGxnHR2W6ERS4xZnjaiEQtkxDJfs/v/VBPLfM3u9plYICMWyIgFMmKBjFggIxbIiAUyYoGMWCAjFsiIBTJigYxYICMWyIgFMmKBjFggIxbIiAUyYoGMWCAjFsiIBTJigYxYICMWyIgFMmKBjFggIxbIiAWyg+VyyW8LEo4skBELZMQCGbFARiyQEQtkxAIZsUBGLJARC2TEAhmxQEYskBELZMQCGbFARiyQEQtkxAIZsUBGLJARC2TEAhmxQEYskBELZMQCGbFAY2b/AAW6/DMwvYP/AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogoJsb);
export default __webpack_public_path__ + "static/media/linkedin-logo-jsb.0867074b07290b9fa44c02ab9d05ca54.svg";
export { ForwardRef as ReactComponent };